module.exports = __webpack_public_path__ + "img/紅底驚嘆號.664f6142.svg";